import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cbreak() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  return (
    <div>
   
      <Sides/>
       <Helmet>
 
       <title>Learn How to Use the Break Statement in C++ - CodeExampler</title>
<meta name="description" content="Master the Break Statement in C++ with CodeExampler! Our free online tutorial teaches you how to use the break keyword to exit loops and switch statements. Get started today!" />
<meta name="keywords" content="break statement in c++, cpp break loop, c++ break while loop, c++ break for loop, c++ break switch, learn c++,break statement in c++, free online tutorial, codeexampler" />
<link rel="canonical" href="https://www.codeexampler.com/cpp-break" />
 </Helmet>
 <div className='lg:pl-56'>
      <h1 className="m-4 mh1">Break Statement in c++</h1>
     
      <div className="first">
        <a href="/cpp-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
     
      <h2 className="mt-4 mh2">break statement in c++ </h2>
      <p className="mt-4 para">1, Break statement in c++ keyword is used to exit from loop and switch<br />
      2, When a break encounter inside any loop, control automatically passes to the first statement after the loop.<br />
3, Break in C++ statement is used to terminate a loop immediately. <br />
4, The break statement is encountered inside a loop<br />
      </p>
   
      
      <h2 className='headings'>Break syntax in c++</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">Break </span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

   
 

      <h2 className='headings'>Q-write a program loop starts from 1 to 10 but stop or break when i=5 in break statement in c++?
</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
              {"\n"}
            <span className="qwerty-11">int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-11">for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">1;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">&#62; =</span>
            <span className="qwerty-5">10;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">++</span>
            <span className="qwerty-3"> )</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
            <span className="qwerty-5">if </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3"> ==</span>
            <span className="qwerty-10"> 5 </span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-10">Break </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
              {"\n"}
            <span className="qwerty-7">cout</span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3"> &#60;&#60; " </span>
              <span className="qwerty-5">\n</span>
            <span className="qwerty-3"> " ;</span>
              {"\n"}
            <span className="qwerty-3">&#125; </span>
              {"\n"}
            <span className="qwerty-3">&#125; </span>
              {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"} 
              <span className="qwerty-10">1 </span>
                {"\n"} 
              <span className="qwerty-10">2 </span>
                {"\n"} 
              <span className="qwerty-10">3 </span>
                {"\n"} 
              <span className="qwerty-10">4 </span>
                {"\n"} 
             </code>{"\n"}</pre>
        </div>
      </div>


 


      <h2 className='headings'>Q-Write a program loop starts from 1 to 10 but stop or break on first even no occur in break statement in c++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">  int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
           {"\n"}
            <span className="qwerty-3">&#123; </span>
              {"\n"}
            <span className="qwerty-11">  int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-11">  for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">1;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">&#60; =</span>
            <span className="qwerty-5">10;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">++</span>
            <span className="qwerty-3"> )</span>
              {"\n"}
              <span className="qwerty-3">  &#123; </span>
              {"\n"}
            <span className="qwerty-5">  if </span>
            <span className="qwerty-3">( </span>
              <span className="qwerty-3">i </span>
            <span className="qwerty-10">% </span>
            <span className="qwerty-10">2 </span>
            <span className="qwerty-3"> ==</span>
            <span className="qwerty-10"> 0 </span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-3">  &#123; </span>
              {"\n"}
              <span className="qwerty-10">   Break </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">  &#125; </span>
              {"\n"}
            <span className="qwerty-7">  cout </span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3"> &#60;&#60; " </span>
              <span className="qwerty-5">\n</span>
            <span className="qwerty-3"> " ;</span>
              {"\n"}
            <span className="qwerty-3">  &#125; </span>
              {"\n"}
            <span className="qwerty-3">&#125; </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"} 
              <span className="qwerty-10">1 </span>
                {"\n"} 
             </code>{"\n"}</pre>
        </div>
      </div>

    

<h2 className='headings'>Q-Write a program loop starts from 1 to 10 but stop or break on first even no occur in break statement in c++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
           {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">  int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-11">  for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-5">1;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">&#60; =</span>
            <span className="qwerty-5">10;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">++</span>
            <span className="qwerty-3"> )</span>
              {"\n"}
              <span className="qwerty-3">  &#123; </span>
              {"\n"}
              <span className="qwerty-7"> if </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3">== </span>
            <span className="qwerty-10">4 </span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-3">  &#123; </span>
              {"\n"}
            <span className="qwerty-7"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
              <span className="qwerty-10">no is </span>
            <span className="qwerty-10">4 </span>
            <span className="qwerty-3">" ;</span>
              {"\n"}
              <span className="qwerty-10"> Break </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7"> cout </span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">This is break </span>
            <span className="qwerty-3"> " ;</span>
            {"\n"}
            <span className="qwerty-3">  &#125; </span>
            {"\n"}
            <span className="qwerty-7"> cout </span>
            <span className="qwerty-3"> &#60;&#60; </span>
              <span className="qwerty-10">i </span>
              <span className="qwerty-3"> &#60;&#60; " </span>
              <span className="qwerty-5">complete \n</span>
            <span className="qwerty-3"> " ;</span>
              {"\n"}
            <span className="qwerty-3">  &#125; </span>
              {"\n"}
            <span className="qwerty-3">&#125; </span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"} 
              <span className="qwerty-5">complete </span>
              {"\n"} 
              <span className="qwerty-5">complete </span>
              {"\n"} 
              <span className="qwerty-5">complete </span>
              {"\n"} 
              <span className="qwerty-10">no is </span>
              <span className="qwerty-5">4 </span>
                {"\n"} 
             </code>{"\n"}</pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>

<div className="back">
        <a href="/cpp-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cbreak;